import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[capHostView]'
})
export class CapturumHostViewDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
